import type { Action, GameState } from '@brig/rules-engine';

/** Selection-dependent hints, all derived from `legalActions` so the UI never offers an illegal move. */
export interface Hints {
  readonly moveCells: ReadonlySet<string>;
  readonly portCells: ReadonlySet<string>;
  readonly targets: ReadonlySet<string>;
  readonly dock: Action | null;
  readonly startFortRepair: Action | null;
  readonly stopFortRepair: Action | null;
}

export function hintsFor(state: GameState, legal: readonly Action[], selected: string | null): Hints {
  const moveCells = new Set<string>();
  const portCells = new Set<string>();
  const targets = new Set<string>();
  let dock: Action | null = null;
  let startFortRepair: Action | null = null;
  let stopFortRepair: Action | null = null;
  if (selected && state.status.kind === 'playing') {
    for (const a of legal) {
      if (a.type === 'moveShip' && a.shipId === selected) moveCells.add(a.to);
      else if (a.type === 'moveInPort' && a.shipId === selected) portCells.add(a.to);
      else if (a.type === 'fire' && a.shooterId === selected) targets.add(a.targetId);
      else if (a.type === 'enterPortRepair' && a.shipId === selected) dock = a;
      else if (a.type === 'startFortRepair' && a.fortId === selected) startFortRepair = a;
      else if (a.type === 'stopFortRepair' && a.fortId === selected) stopFortRepair = a;
    }
  }
  return { moveCells, portCells, targets, dock, startFortRepair, stopFortRepair };
}
